import { DRAFTS_GROUP_LINKS } from "../../config";

export const SETTINGS_LINKS = {
  MARKETPLACE: `${DRAFTS_GROUP_LINKS.SETTINGS}/marketplace`,
  AUTOMATION_SETUP: `${DRAFTS_GROUP_LINKS.SETTINGS}/automation-setup`,
  EMPLOYEE: `${DRAFTS_GROUP_LINKS.SETTINGS}/employee-management`,
  SUBSCRIPTION: `${DRAFTS_GROUP_LINKS.SETTINGS}/subscription`,
  PAYMENT: `${DRAFTS_GROUP_LINKS.SETTINGS}/payment`,
}